import { Price } from 'src/store/price/types';

const addExtraPrice = (priceA: Price, priceB: Price, quantity = 1) => ({
  price: priceA.price + priceB.price * quantity,
  priceInitial: priceA.priceInitial + priceB.priceInitial * quantity,
} as Price);

export default addExtraPrice;
